import { createContext, RefObject } from 'react';

export interface ScrollContextSettings {
  scrollRef: RefObject<HTMLDivElement> | null;
  jumpToBottom: () => void;
  scrollToBottom: () => void;
  startTail: () => void;
  stopTail: () => void;
  atBottom: boolean;
  tailing: boolean;
}

export const ScrollContext = createContext<ScrollContextSettings>({
  scrollRef: null,
  jumpToBottom: () => null,
  scrollToBottom: () => null,
  startTail: () => null,
  stopTail: () => null,
  atBottom: true,
  tailing: false,
});
